import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import RideDetailsCard from "../components/RideDetailsCard";
import { fetchRideById } from "../utils/api";

export default function RidePage({ user }) {
  const { id } = useParams();
  const token = localStorage.getItem("travelo_token");

  const [ride, setRide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRide = async () => {
      try {
        const data = await fetchRideById(id, token);
        setRide(data);
      } catch (err) {
        console.error("❌ Error:", err);
        setError(err.response?.data?.error || "Failed to load ride");
      } finally {
        setLoading(false);
      }
    };

    loadRide();
  }, [id, token]);

  if (loading) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <p>Loading ride details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "red" }}>
        <p>❌ {error}</p>
      </div>
    );
  }

  if (!ride) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <p>🚗 Ride not found</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <RideDetailsCard ride={ride} user={user} onRideUpdate={setRide} />
    </div>
  );
}